import { makeStyles, Theme, Typography } from '@material-ui/core';
import React, { CSSProperties, useCallback, useState } from 'react';
import { SearchBox } from '@moderepo/mode-app-components';
import clsx from 'clsx';
import { useRitzTranslation } from '../../utils/customHooks';
import { useSelectProject } from '../../utils/dataStateHooks';

const useStyle = makeStyles((theme: Theme) => {
    return {
        root: {
            padding: theme.spacing(1, 1),
        },

        searchBoxContainer: {
            display       : 'flex',
            flexDirection : 'row',
            alignItems    : 'center',
            justifyContent: 'flex-start',
            width         : '100%',
            maxWidth      : 500,
        },

        searchLabel: {
            textTransform: 'capitalize',
            marginRight  : theme.spacing(1),
            whiteSpace   : 'nowrap',
        },

        searchButton: {
            marginLeft: theme.spacing(1),
        },

        [theme.breakpoints.up('md')]: {
            root: {
                padding: theme.spacing(2),
            },
        },

        [theme.breakpoints.up('lg')]: {
            root: {
                padding: theme.spacing(2, 3),
            },
        },
    };
}, { name: 'GlobalSearchBar', index: 1 });



export interface GlobalSearchBarProps {
    readonly className?: string | undefined;
    readonly style?: CSSProperties | undefined;
    readonly projectId: number;
    readonly initialValue?: string | undefined;
    readonly texts?: {
        readonly searchBoxPlaceholder: string;
    } | undefined;
    readonly onSearchTextChange: (searchText: string)=> void;
}


/**
 * This is the GlobalSearchBar which can be used to search for ANY THING in the project.
 * TODO - Add more options later. Right now it have 1 text field for the user to enter searchText.
 */
export const GlobalSearchBar: React.FC<GlobalSearchBarProps> = (props: GlobalSearchBarProps) => {

    const project = useSelectProject(props.projectId);
    const { trans } = useRitzTranslation(project);
    const classes = useStyle();
    const [searchText, setSearchText] = useState<string>(props.initialValue ?? '');

    const onSearchTextChanged = useCallback((value: string) => {
        setSearchText(value);
        props.onSearchTextChange(searchText.trim());
    }, [props, searchText]);


    return (
        <div className={clsx(props.className, classes.root)}>
            <div className={classes.searchBoxContainer}>
                <Typography
                    component="h4"
                    variant="h5"
                    className={classes.searchLabel}
                >
                    {trans('label.search')}
                </Typography>
                <SearchBox
                    initialValue={props.initialValue}
                    placeholder={props.texts?.searchBoxPlaceholder}
                    delay={1000}
                    onChange={onSearchTextChanged}
                />
            </div>
        </div>
    );
};
